export type EngineerTestimonialSection = {
  name: string;
  title: string;
  message: string;
  image: string;
};

export type EngineerTestimonialData = {
  title: string;
  sections: EngineerTestimonialSection[];
};

export const engineerTestimonials: EngineerTestimonialData = {
  title: "What Our Engineers Say",
  sections: [
    {
      name: "Kyle",
      title: "",
      message:
        "Working at HC has allowed me to learn from experienced engineers and spend more time with my family through a flexible work environment",
      image: "/assets/ing/kyle.jpeg",
    },
    {
      name: "Thaisa",
      title: "",
      message:
        "Working at HC has shown me how much care and detail go into every estimate we deliver, helping me grow as an engineer while making a real difference for our clients.",
      image: "/assets/ing/thaisa.jpeg",
    },
    {
      name: "Mark",
      title: "",
      message:
        "HC's commitment to professional growth empowered me to learn and develop my skills, culminating in advancing to a Lead Estimator.",
      image: "/assets/ing/mark.jpeg",
    },
  ],
};
